import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ApptMessageLoading = (props: SvgIconProps): JSX.Element => (
	<SvgIcon viewBox={'0 0 174 21'} width={'174px'} height={'21px'} {...props}>
		<g stroke={'none'} strokeWidth={'1'} fill={'none'} fillRule={'evenodd'}>
			<rect fill={'#EFEFF1'} x={'0'} y={'5'} width={'174'} height={'13'} rx={'2'}></rect>
		</g>
	</SvgIcon>
);
